export const EAGER_LOAD_IMAGES = 2;
export const EAGER_LOAD_INVENTORIES = 3;
